import { resolve } from 'library/helpers/path-resolver';
import { matchPath } from 'library/util/core-router';
import { ScreenSizeMapping } from 'library/mappings/screen-size-mapping';

const sortCache = {};

export const HandleLinkSort = (a, b, { pathname }) => {
  if (window.innerWidth >= ScreenSizeMapping.laptop) {
    return 0;
  }

  pathname = `/journey${pathname}`;

  const pathCache = resolve(sortCache, pathname, {});

  let aPath = resolve(a, 'props/to', '');
  if (typeof aPath === 'object') {
    aPath = aPath.pathname;
  }

  let bPath = resolve(b, 'props/to', '');
  if (typeof bPath === 'object') {
    bPath = bPath.pathname;
  }

  if (!pathCache[aPath]) {
    pathCache[aPath] = matchPath(pathname, {
      path: aPath,
      exact: resolve(a, 'props/exact', false),
      strict: resolve(a, 'props/strict', false)
    }) ? 1 : 0;
  }
  if (!pathCache[bPath]) {
    pathCache[bPath] = matchPath(pathname, {
      path: bPath,
      exact: resolve(b, 'props/exact', false),
      strict: resolve(b, 'props/strict', false)
    }) ? 1 : 0;
  }

  sortCache[pathname] = pathCache;

  return pathCache[aPath] > pathCache[bPath] ? -1 : 1;
};
